var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useState, useEffect, useRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import { OutlinedInput } from '@material-ui/core';
import StartAdornment from './components/StartAdornment';
import { addWhitespaces, isAddingNewGroup, removeWhitespaces, setCaretToPosition, DIGITS_GROUPS, MAX_LENGTH, } from './utils';
/**
 *
 * API:
 *
 * - [CreditCardNumber API](https://components-extra.netlify.app/components/credit-card-number)
 * - inherits [OutlinedInput API](https://material-ui.com/api/outlined-input/)
 */
const CreditCardNumber = (_a) => {
    var { forwardedRef, inputProps, onChange } = _a, rest = __rest(_a, ["forwardedRef", "inputProps", "onChange"]);
    const [value, setValue] = useState('');
    const [caretPosition, setCaretPosition] = useState(0);
    const input = useRef();
    useImperativeHandle(forwardedRef, () => input.current || new HTMLInputElement());
    useEffect(() => {
        if (input.current && caretPosition !== 0) {
            setCaretToPosition(input.current, caretPosition);
        }
    }, [value, caretPosition, input]);
    const onChangeValue = (event) => {
        let newCaretPosition = event.target.selectionStart || 0;
        const newValue = event.target.value;
        const digitsOnly = removeWhitespaces(newValue);
        const spacedValue = addWhitespaces(digitsOnly);
        if (isAddingNewGroup(value, newValue)) {
            newCaretPosition += Math.floor(value.length / DIGITS_GROUPS);
        }
        setValue(spacedValue);
        setCaretPosition(newCaretPosition);
        onChange && onChange(event);
    };
    return (React.createElement(OutlinedInput, Object.assign({ autoComplete: "cc-number", inputRef: input, placeholder: "XXXX XXXX XXXX XXXX", inputProps: Object.assign({ 'aria-label': 'credit-card number', maxLength: MAX_LENGTH }, inputProps), onChange: onChangeValue, startAdornment: React.createElement(StartAdornment, null), ref: forwardedRef }, rest, { value: value })));
};
const CreditCardNumberExtra = styled(forwardRef((props, ref) => (React.createElement(CreditCardNumber, Object.assign({}, props, { forwardedRef: ref }))))) ``;
export default CreditCardNumberExtra;
